module.exports = __webpack_public_path__ + "media/icons-lj-styleguide-2025/checkbox-default-cd3fbd42.svg";